/**
 * Platform → Sending Infra — Task #250.
 *
 * The Sending Infrastructure surface has been merged into the Email Settings
 * page (/platform/email-settings, "Sending Infrastructure" tab). This route is
 * kept as a redirect so existing bookmarks/links don't break.
 */

import { Redirect } from "wouter";

export default function PlatformInfra() {
  return <Redirect to="/platform/email-settings" />;
}
